import "./Loading.scss";
export default function Loading() {
    return <div className="lds-facebook"><div></div><div></div><div></div></div>
}